import React from 'react';
import { Badge } from 'react-bootstrap';

const TotalCount = ({ totalCount }) => {
  return (
    <div className="d-flex align-items-center">
      <span className="me-2">Total de resultados:</span>
      <Badge bg="primary" pill>{totalCount.toLocaleString()}</Badge>
    </div>
  );
};

export default TotalCount;
